import { EMPTY_VALUE } from "./ChipsCell.const"

import styles from "./ChipsCell.module.scss"

export const EmptyValue = () => (
  <span className={styles.empty}>{EMPTY_VALUE}</span>
)
